import WebMidi from "webmidi";
import numTowords from "number-to-words";
import colorConvert from "color-convert";
import { logScale, scale } from "./utils";

const LOW_NOTE = 21;
const HIGH_NOTE = 80;

const noteContainer1 = document.createElement("div");
noteContainer1.id = "noteContainer1";
noteContainer1.style = `
  width: 100vw;
  height: 50vh;
  background-color: pink;
`;

const noteContainer2 = document.createElement("div");
noteContainer2.id = "noteContainer2";

noteContainer2.style = `
width: 100vw;
height: 50vh;
background-color: darkblue;
`;

document.body.appendChild(noteContainer1);
document.body.appendChild(noteContainer2);

WebMidi.enable(function (err) {
  if (err) console.log("An error occurred", err);

  var IACBus1 = WebMidi.getInputByName("IAC Driver Bus 1");
  var IACBus2 = WebMidi.getInputByName("IAC Driver Bus 2");

  IACBus1.addListener("noteon", "all", appendBus1Notes.bind(noteContainer1));
  IACBus1.addListener("noteoff", "all", removeBus1Notes.bind(noteContainer1));

  IACBus2.addListener("noteon", "all", appendBus2Notes.bind(noteContainer2));
  IACBus2.addListener("noteoff", "all", removeBus2Notes.bind(noteContainer2));
});

function appendBus1Notes(e) {
  // create element with note name id
  const element = document.createElement("div");
  element.id = this.id + numTowords.toWords(e.note.number);
  const parentHeight = parseInt(
    window.getComputedStyle(this).height.slice(0, -2)
  );
  element.style = bus1Style(e.note.number, parentHeight, e.velocity);
  this.appendChild(element);
}

function removeBus1Notes(e) {
  const element = document.querySelector(
    `#${this.id}${numTowords.toWords(e.note.number)}`
  );
  this.removeChild(element);
}

function appendBus2Notes(e) {
  // create element with note name id
  const element = document.createElement("div");
  element.id = this.id + numTowords.toWords(e.note.number);
  const parentHeight = parseInt(
    window.getComputedStyle(this).height.slice(0, -2)
  );

  element.style = bus2Style(e.note.number, parentHeight, e.velocity);
  this.appendChild(element);
}

function removeBus2Notes(e) {
  const element = document.querySelector(
    `#${this.id}${numTowords.toWords(e.note.number)}`
  );
  this.removeChild(element);
}

function bus1Style(noteNumber, parentHeight, velocity) {
  const scaledLightness = scale(noteNumber, LOW_NOTE, HIGH_NOTE, 40, 60);
  const cmykVar = scale(noteNumber, LOW_NOTE, HIGH_NOTE, 0, 100);
  const rgbVar = scale(noteNumber, LOW_NOTE, HIGH_NOTE, 0, 255);
  const left = scale(noteNumber, LOW_NOTE, HIGH_NOTE, 0, 800);
  const width = scale(noteNumber, LOW_NOTE, HIGH_NOTE, 100, 50);
  const rgb = colorConvert.cmyk.rgb([100 - cmykVar, 100, 50, 0]);

  //const rgb = [rgbVar, 0, 0];
  return `
  position: absolute;
  bottom: ${parentHeight};
  left: ${(100 / (HIGH_NOTE - LOW_NOTE)) * (noteNumber - LOW_NOTE)}%;
    background-color: rgb(${rgb[0]}, ${rgb[1]}, ${rgb[2]});
    width: ${100 / (HIGH_NOTE - LOW_NOTE)}%;
    height: ${parentHeight * velocity};
    mix-blend-mode: multiply;
  `;
}

function bus2Style(noteNumber, parentHeight, velocity) {
  const scaledLightness = scale(noteNumber, LOW_NOTE, HIGH_NOTE, 40, 60);
  const cmykVar = scale(noteNumber, LOW_NOTE, HIGH_NOTE, 0, 100);
  const rgbVar = scale(noteNumber, LOW_NOTE, HIGH_NOTE, 0, 255);
  const left = scale(noteNumber, LOW_NOTE, HIGH_NOTE, 0, 800);
  const width = scale(noteNumber, LOW_NOTE, HIGH_NOTE, 100, 50);
  const rgb = colorConvert.cmyk.rgb([0, 100 - cmykVar, 0, 0]);
  //const rgb = [rgbVar, 0, 0];
  return `
  position: absolute;
  display: inline-block;
  left: ${
    Math.round(100 / (HIGH_NOTE - LOW_NOTE)) * (noteNumber + 12 - LOW_NOTE)
  }%;
    background-color: rgb(${rgb[0]}, ${rgb[1]}, ${rgb[2]});
    width: ${Math.round(100 / (HIGH_NOTE - LOW_NOTE))}%;
    height: ${parentHeight * velocity};
    mix-blend-mode: normal;
  `;
}
